export default build =>
    build.mutation({
        query(payload) {
            console.log("In get school by section",payload)
            return {
                url: '/school/getSchoolsBySection',
                method: 'POST',
                body: payload,
               
            };
        },
        //invalidatesTags: ['allSchools'],
    })
